package com.essntl.features.client.data.supabase

import com.essntl.features.client.domain.model.ClientModel
import core.dateformat.utils.fromDDTOMM
import kotlinx.serialization.json.JsonElement
import kotlinx.serialization.json.JsonPrimitive

internal fun ClientModel.toRequestMap(): Map<String, JsonElement> {
    val requestMap = mutableMapOf<String, JsonElement>()

    firstName?.let {
        requestMap["first_name"] = JsonPrimitive(it)
    }

    requestMap["last_name"] = JsonPrimitive(lastName)

    dateOfBirth?.let {
        requestMap["date_of_birth"] = JsonPrimitive(fromDDTOMM(it))
    }

    notes?.let {
        requestMap["notes"] = JsonPrimitive(it)
    }

    telephone?.let {
        requestMap["telephone"] = JsonPrimitive(it)
    }

    email?.let {
        requestMap["email"] = JsonPrimitive(it)
    }

    salutation?.let {
        requestMap["salutation"] = JsonPrimitive(it)
    }

    travelAgent?.let { travelAgent ->
        requestMap["travel_agent"] = JsonPrimitive(if (travelAgent.isEmpty) null else travelAgent.id)
    }

    qbCustomerId?.let {
        requestMap["qb_customer_id"] = JsonPrimitive(it)
    }

    return requestMap
}
